window.onload = () => {
    const videos = document.querySelectorAll(".wp-block-video");

    for (const video of videos) {
        video.setAttribute("playsinline", "");
        video.setAttribute("muted", "");
        if (video.hasAttribute('autoplay')) {
            video.play()
                .then(() => {})
                .catch((error) => {
                    video.play();
                });
        }
    }

    // Add toggle functionality
    const toggleButtons = document.querySelectorAll(".video-link-block__toggle");
    toggleButtons.forEach(button => {
        const container = button.closest('.video-link-block__container');
        const video = container.querySelector('video');

        button.addEventListener('click', () => {
            if (video.paused) {
                video.play();
                container.classList.remove('paused');
            } else {
                video.pause();
                container.classList.add('paused');
            }
        });
    });
};
